module.exports = __webpack_public_path__ + "img/mainmenbuttonGREEN6.57a682c5.png";